module.exports = __webpack_public_path__ + "img/ventilation.e0f857a4.svg";